import { Directive } from '@angular/core';

@Directive({
  selector: '[appPrefix], [appIconPrefix]',
})
export class FormFieldPrefixDirective {}

@Directive({
  selector: '[appSuffix], [appIconSuffix]',
})
export class FormFieldSuffixDirective {}
